import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * The encryption feature is enabled when
 * 1. You're a premium consumer user with the cmp-encryption feature flag enabled (get the ProtectMessage version)
 * 2. You're an enterprise user with SegmentationSettings.Irm = true
 */
export default function isEncryptionEnabled() {
    return isConsumer()
        ? isFeatureEnabled('cmp-encryption') &&
              getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox
        : getUserConfiguration().SegmentationSettings.Irm;
}
